"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CloseButton = ({ color, backgroundColor, onHoverColor, onClick }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: `header-close-container ${backgroundColor}`, onClick: onClick },
            react_1.default.createElement("div", { className: "cros" },
                react_1.default.createElement("span", { className: "one" }),
                react_1.default.createElement("span", { className: "two" })))));
};
exports.default = CloseButton;
//# sourceMappingURL=index.js.map